import React, { useEffect, useState } from "react";
import { AiOutlineRight } from "react-icons/ai";
import { useParams } from "react-router";
import RestaurantRatings from "./RestaurantRatings";

import Rating from "react-rating";
import { useDispatch, useSelector } from "react-redux";
import {
  addWishlistRes,
  fetchWishListRes,
  restaurantRatingAction
} from "../../redux/actions/restaurantAction";

function getLatLngFromLocalStorage() {
  return localStorage.getItem("latlng") ? localStorage.getItem("latlng") : "";
}
const RestaurantDetailsInfo = (props) => {
  console.log({props});
  const [modalIsOpen, setIsOpen] = useState(false);
  // const [ratings, setratings] = useState([]);
  const { id } = useParams();
  const { resRating, wishlist, wishlistNotifyMessage } = useSelector((state) => state.restaurant);
  
  // console.log(resRating);
  console.log({wishlist});
  console.log({wishlistNotifyMessage});
  // console.log(useSelector((state) => state.restaurant));
  const dispatch = useDispatch();
  
  const handleReviewPopUp = () => {
    setIsOpen(true);
    dispatch(restaurantRatingAction(id));
  };
  // console.log("ratings: ", ratings);
  const closeModal = () => {
    setIsOpen(false);
  };
// wishlist 

  useEffect(() => {
    let data = getLatLngFromLocalStorage();
    if (data) {
      let formateArr = data.split(",");
      let res = Object.assign(
        {},
        {
          lat: formateArr[0],
          lng: formateArr[1],
        }

        
      );
      dispatch(fetchWishListRes(res));
    } else {
      dispatch(fetchWishListRes());
    }
    
   
  }, [ dispatch, wishlistNotifyMessage ]);

 
 
console.log(props);
  return (
    <div className="grid xl:grid-cols-7 gap-10">
      <div className="pr-thumb relative xl:col-span-4 md:col-span-3 max-h-[350px] ">
        <img
          className="rounded-lg w-full h-full"
          src={props.image}
          alt=""
        />
        {props?.user?.id ? (
          props.wishlist ? (
            <span
              onClick={() =>( dispatch(addWishlistRes(id))
                )}
              className="absolute top-3 right-3 bg-[#FBD336] h-8 w-8 flex justify-center items-center rounded-sm rounded-br-2xl cursor-pointer"
            >
              {/* <defs><style>.cls-1{fill:#95cd84;}.cls-2{fill:#fff;}</style></defs> */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 48 48"
                className=" fill-[#0DC1D9]"
              >
                <g id="Layer_2" data-name="Layer 2">
                  <path
                    className="cls-1 fill-white"
                    d="M2.66,0H45.34A2.66,2.66,0,0,1,48,2.66V27A21,21,0,0,1,27,48H2.66A2.66,2.66,0,0,1,0,45.34V2.66A2.66,2.66,0,0,1,2.66,0Z"
                  />
                  <path
                    className="cls-2"
                    d="M13.87,21.41V20.3l.12-.68a5,5,0,0,1,5.75-4A6.76,6.76,0,0,1,23,17c.35.26.68.56,1,.86l.14-.13a8.19,8.19,0,0,1,1.93-1.43,6,6,0,0,1,4-.68,5,5,0,0,1,4,4.91,6.4,6.4,0,0,1-.69,3.13,14.4,14.4,0,0,1-2.8,3.77,32.63,32.63,0,0,1-6.51,4.95.2.2,0,0,1-.25,0c-1-.69-2.11-1.34-3.13-2.07A23.26,23.26,0,0,1,16,25.87a9.73,9.73,0,0,1-1.87-3.43C14,22.1,14,21.75,13.87,21.41Z"
                  />
                </g>
              </svg>
            </span>
          ) : (
            <span
              onClick={() => dispatch(addWishlistRes(id))}
              className="absolute top-3 right-3 bg-[#FBD336] h-8 w-8 flex justify-center items-center rounded-sm rounded-br-2xl cursor-pointer"
            >
              {/* <defs><style>.cls-1{fill:#95cd84;}.cls-2{fill:#fff;}</style></defs> */}

              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
                <g id="Layer_2" data-name="Layer 2">
                  <path
                    className="cls-1 fill-white"
                    d="M2.66,0H45.34A2.66,2.66,0,0,1,48,2.66V27A21,21,0,0,1,27,48H2.66A2.66,2.66,0,0,1,0,45.34V2.66A2.66,2.66,0,0,1,2.66,0Z"
                  />
                  <path
                    className="cls-2 fill-black"
                    d="M13.84,20.48c.06-.35.11-.71.2-1.05a5.24,5.24,0,0,1,4.41-4,6.33,6.33,0,0,1,4.36,1c.41.25.8.56,1.2.86l.7-.55a7.13,7.13,0,0,1,3.34-1.36,5.33,5.33,0,0,1,6,4.33,6.87,6.87,0,0,1-1,4.92,16.16,16.16,0,0,1-3,3.62,32.82,32.82,0,0,1-5.59,4.13.78.78,0,0,1-.9,0,31.31,31.31,0,0,1-6.5-5,12.48,12.48,0,0,1-2.71-4,6.15,6.15,0,0,1-.47-1.79.45.45,0,0,0,0-.11Zm5.42-3.78h-.42a1.6,1.6,0,0,0-.23,0,3.88,3.88,0,0,0-3.18,2.52,5,5,0,0,0,.22,4,12.26,12.26,0,0,0,2.52,3.45,30.06,30.06,0,0,0,5.7,4.41.24.24,0,0,0,.27,0A31.81,31.81,0,0,0,29,27.54,14.94,14.94,0,0,0,32,24.05a5.56,5.56,0,0,0,.86-3.87,4,4,0,0,0-2-3A4.41,4.41,0,0,0,27,17a6.75,6.75,0,0,0-2.49,1.62.67.67,0,0,1-1.1,0,7.17,7.17,0,0,0-.58-.52A5.72,5.72,0,0,0,19.26,16.7Z"
                  />
                </g>
              </svg>
            </span>
          )
        ) : null}
      </div>
      <div className="pr-text max-w-[400px] xl:col-span-3 md:col-span-3">
        <h4 className="text-black font-medium text-3xl mb-1">{props.name}</h4>
        <ul className="list-none flex flex-wrap items-center gap-3">
          {props?.categories?.map((category) => (
            <li key={category.id}>
              <p className="text-[#848587] font-normal text-sm">
                {category.name}
              </p>
            </li>
          ))}
        </ul>
        
        <p className="text-[#848587] text-sm font-normal pt-1">
          {/* {props.open_time && moment(props.open_time).format()} */}
          Opeaning at {props.open_time}-Closes at {props.close_time}
        </p>
        <div className="flex gap-6">
          <p className="text-[#848587] text-sm font-normal pt-1">
            {props?.road}, {props?.city}, {props?.country}
          </p>
          <p className="text-[#848587] text-sm font-normal pt-1">
            £{props.delivery_charge} Delivery Fee
          </p>
        </div>
        <div className="flex gap-4 pt-4">
          <svg
            className="h-8 w-8"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.63524 9.79918C2.52845 9.79918 2.45841 9.79918 2.38836 9.79918C2.13587 9.79918 2.0468 9.70867 2.0455 9.44483C2.0455 9.15158 2.0455 8.85652 2.0455 8.53973H1.86391C1.35156 8.53973 0.839215 8.53973 0.326867 8.53973C0.0804217 8.53973 0 8.45329 0 8.19308C0 7.06411 0 5.93499 0 4.80573C0 4.54415 0.0864724 4.44912 0.340701 4.44866C1.52768 4.44866 2.71436 4.44866 3.90076 4.44866C4.15196 4.44866 4.24016 4.54415 4.24103 4.80573C4.24103 5.13156 4.24103 5.4574 4.25616 5.79048C4.57577 5.06129 5.0342 4.40805 5.6034 3.87076C5.51174 3.78025 5.42483 3.70603 5.34917 3.62004C4.80137 3.0005 4.62367 2.27868 4.87919 1.47812C5.13472 0.677553 5.68771 0.191512 6.48671 0.0353816C6.98393 -0.0614644 7.44958 0.0435282 7.88281 0.313249C7.99782 0.384752 8.06613 0.49427 8.01597 0.623699C7.97399 0.716033 7.89945 0.787733 7.80801 0.823727C7.74315 0.846354 7.64371 0.795669 7.57151 0.754034C7.37102 0.636671 7.14784 0.568078 6.91856 0.553348C6.68927 0.538618 6.45976 0.578127 6.24706 0.668945C6.03436 0.759763 5.84394 0.899558 5.68992 1.07795C5.5359 1.25634 5.42224 1.46875 5.35739 1.69941C5.30084 1.90455 5.28424 2.11948 5.30856 2.33146C5.33287 2.54344 5.39762 2.74815 5.49896 2.93344C5.60029 3.11874 5.73615 3.28084 5.89848 3.41013C6.0608 3.53942 6.24628 3.63327 6.44391 3.68612C6.48322 3.69314 6.52295 3.69738 6.56281 3.69879V3.51098C6.56281 2.84482 6.56281 2.17867 6.56281 1.51251C6.56281 1.20749 6.64279 1.12648 6.94069 1.12648C7.64169 1.12648 8.34284 1.12648 9.04413 1.12648C9.08171 1.12422 9.11939 1.12422 9.15697 1.12648C9.30917 1.14504 9.4138 1.25772 9.41639 1.40118C9.41898 1.54464 9.31695 1.6614 9.16043 1.67271C9.02683 1.68267 8.89151 1.67271 8.7311 1.67271V1.86505C8.7311 2.24881 8.73413 2.63439 8.7311 3.01679C8.72418 3.76169 8.22826 4.2785 7.51573 4.28756C7.37738 4.28756 7.23902 4.28756 7.08986 4.28756C7.23643 4.57131 7.35403 4.85008 7.51487 5.09808C7.86551 5.63842 8.38867 5.81809 8.98922 5.80044C9.02644 5.79805 9.06193 5.78312 9.09039 5.7579C9.58544 5.29765 10.4528 5.50085 10.6625 6.34259C10.7896 6.34259 10.9219 6.34259 11.0559 6.34259C11.1178 6.33968 11.1795 6.35331 11.235 6.38221C11.2905 6.4111 11.3381 6.45432 11.3733 6.50777C11.8411 7.15613 12.3112 7.80267 12.7836 8.44741C12.8632 8.55693 12.8848 8.67369 12.8143 8.79225C12.7875 8.84378 12.7436 8.88331 12.6909 8.90346C12.6382 8.92362 12.5804 8.92301 12.5281 8.90177C12.4541 8.8709 12.39 8.81883 12.343 8.75152C11.9245 8.18448 11.5107 7.61336 11.0961 7.04314C11.0628 6.99507 11.0189 6.95619 10.968 6.92988C10.9172 6.90357 10.861 6.89061 10.8043 6.89213C10.7476 6.89364 10.6921 6.90958 10.6426 6.93858C10.5931 6.96757 10.5511 7.00874 10.5202 7.05853C10.5049 7.09466 10.4826 7.12715 10.4549 7.15402C10.2625 7.2848 10.304 7.44365 10.3723 7.63146C10.5133 8.02065 10.6348 8.41799 10.7615 8.81217C10.8332 9.03301 10.787 9.11402 10.6101 9.24978C10.3378 9.45886 10.0762 9.68378 9.82151 9.91639C9.68532 10.0408 9.49551 10.087 9.38915 9.98382C9.28279 9.88064 9.28193 9.7055 9.42028 9.56612C9.64511 9.33984 9.88248 9.12759 10.1224 8.91942C10.1847 8.86557 10.2189 8.82891 10.1895 8.74293C10.055 8.34513 9.92485 7.94553 9.81157 7.60204C9.57161 7.51153 9.36883 7.43234 9.16303 7.35586C9.13368 7.34334 9.10218 7.33733 9.0705 7.33821C8.54789 7.38345 8.02218 7.30743 7.53086 7.11555C7.5109 7.11015 7.49048 7.10681 7.4699 7.10559L7.43661 7.14361C7.46956 7.18334 7.50685 7.21889 7.54773 7.24951C8.04927 7.53552 8.5521 7.81791 9.05407 8.10121C9.29144 8.23697 9.31781 8.30033 9.26204 8.57639C9.09644 9.39098 8.93301 10.2056 8.76396 11.046L9.44752 11.3342C9.58112 11.0849 9.69267 10.8333 9.8414 10.6102C10.0838 10.2416 10.3988 9.93167 10.7653 9.70125C11.1317 9.47084 11.5411 9.32528 11.9658 9.27438C12.3905 9.22348 12.8207 9.26842 13.2274 9.40618C13.6342 9.54393 14.008 9.7713 14.3237 10.073C14.3436 10.092 14.363 10.1114 14.3821 10.1314C14.5221 10.2762 14.5386 10.4418 14.4253 10.5608C14.312 10.6798 14.1607 10.6667 14.021 10.531C13.6044 10.1147 13.0637 9.86093 12.4896 9.8123C11.2712 9.69147 10.0809 10.6292 9.86734 11.894C9.8414 12.0488 9.83578 12.2077 9.82108 12.3642C9.80076 12.5824 9.71688 12.6706 9.51281 12.6711C8.72043 12.6711 7.92777 12.6711 7.13482 12.6711C6.91388 12.6711 6.83822 12.5837 6.82741 12.3543C6.77466 11.2464 6.27053 10.4341 5.29729 10.0087C4.32404 9.58331 3.42949 9.77655 2.64605 10.5169C2.49861 10.6563 2.35853 10.6817 2.24395 10.5821C2.21524 10.5583 2.19183 10.5282 2.17533 10.494C2.15883 10.4598 2.14964 10.4222 2.14841 10.3839C2.14718 10.3455 2.15392 10.3074 2.16818 10.2721C2.18244 10.2368 2.20387 10.2051 2.23098 10.1793C2.35205 10.0558 2.48391 9.94264 2.63524 9.79918ZM7.39121 12.1162H9.29879C9.3818 11.9162 9.28928 11.8447 9.13406 11.7881C8.90534 11.7062 8.68311 11.6044 8.45785 11.5112C8.22351 11.4139 8.17552 11.3265 8.22264 11.0727C8.24642 10.9459 8.27409 10.8197 8.30003 10.693C8.44487 9.97839 8.58972 9.26381 8.73542 8.5438C8.38953 8.34921 8.04364 8.17588 7.72283 7.96454C7.32203 7.70296 6.90653 7.54547 6.42921 7.61834C6.42388 7.61879 6.41853 7.61879 6.41321 7.61834C6.21778 7.61426 6.0898 7.50474 6.08937 7.34137C6.08894 7.178 6.21173 7.06984 6.41278 7.06487C6.54724 7.06079 6.68257 7.05898 6.81704 7.06487C6.90654 7.06894 6.93939 7.02821 6.95539 6.94177C6.97355 6.84176 6.93118 6.78881 6.85897 6.73405C6.52929 6.48541 6.26101 6.15806 6.0764 5.77917C5.99944 5.62213 6.03317 5.47596 6.15682 5.39495C6.29691 5.30444 6.44693 5.35422 6.54292 5.53931C6.83865 6.11043 7.28961 6.47745 7.88324 6.65802C8.17119 6.74853 8.4652 6.80329 8.7605 6.77478V6.34169L8.4652 6.2996C7.90313 6.21814 7.43834 5.96652 7.12185 5.46238C7.00079 5.27005 6.89875 5.06413 6.79628 4.85958C6.63415 4.53555 6.373 4.37128 6.0336 4.34277C5.95606 4.33909 5.88007 4.36625 5.82088 4.4188C5.15072 5.09762 4.69674 5.90905 4.49656 6.868C4.36382 7.50972 4.60032 7.94598 5.18833 8.16321C5.95361 8.4465 6.71903 8.7298 7.4846 9.0131C7.67787 9.0846 7.74834 9.18281 7.72802 9.35568C7.69386 9.64667 7.65495 9.93676 7.61993 10.2273C7.54124 10.8545 7.46731 11.4813 7.39164 12.1149L7.39121 12.1162ZM0.522728 7.98626H3.71182V5.01797H0.524887V5.80044H2.87434C2.92293 5.79824 2.97161 5.79945 3.02004 5.80406C3.08805 5.80916 3.15153 5.84159 3.19722 5.89456C3.24291 5.94752 3.26726 6.01693 3.26519 6.08826C3.26043 6.2281 3.16229 6.33128 3.01529 6.34757C2.96164 6.35187 2.9078 6.35323 2.85401 6.35164H0.522728V7.98626ZM2.58811 8.53973V9.2525C3.17699 9.2525 3.75333 9.243 4.32923 9.2525C5.45337 9.27467 6.31809 9.79013 6.9234 10.7848C6.94372 10.8183 6.96923 10.8482 7.00771 10.9011C7.06608 10.4119 7.12098 9.95486 7.17762 9.48149C6.88708 9.37288 6.59999 9.26517 6.3129 9.15837C5.40494 8.81986 4.51601 8.38903 3.50775 8.5343C3.33826 8.55919 3.16186 8.53747 2.98891 8.53747L2.58811 8.53973ZM8.18848 1.69398H7.09548V3.73046C7.29004 3.73046 7.47379 3.74178 7.65539 3.72775C7.9148 3.70784 8.17422 3.46301 8.1833 3.19283C8.20102 2.70182 8.18848 2.20401 8.18848 1.69398ZM9.27717 6.53266C9.27619 6.59177 9.28648 6.65048 9.30743 6.70537C9.32837 6.76027 9.35957 6.81024 9.39918 6.85237C9.43879 6.89451 9.48602 6.92796 9.53812 6.95076C9.59022 6.97357 9.64614 6.98528 9.70261 6.98522C9.76034 6.98695 9.8178 6.97638 9.87151 6.95416C9.92522 6.93194 9.97406 6.89853 10.0151 6.85595C10.0561 6.81338 10.0884 6.76253 10.11 6.70649C10.1317 6.65045 10.1422 6.59039 10.141 6.52995C10.1413 6.4106 10.0967 6.29592 10.017 6.2106C9.93727 6.12528 9.82872 6.07615 9.71472 6.07378C9.65699 6.07305 9.59971 6.08442 9.54625 6.10724C9.49279 6.13005 9.44424 6.16384 9.40346 6.20661C9.36268 6.24938 9.33049 6.30027 9.3088 6.35626C9.28711 6.41226 9.27636 6.47224 9.27717 6.53266Z"
              fill="url(#paint0_linear_1770_6001)"
            />
            <path
              d="M14.3036 12.4104C14.303 12.6857 14.2505 12.9581 14.1493 13.2121C14.0481 13.4661 13.9 13.6968 13.7136 13.8909C13.5272 14.085 13.306 14.2388 13.0628 14.3434C12.8196 14.4481 12.5591 14.5015 12.2961 14.5008C12.0318 14.5002 11.7702 14.4451 11.5263 14.3384C11.2824 14.2317 11.061 14.0757 10.8749 13.8792C10.6887 13.6828 10.5415 13.4498 10.4417 13.1936C10.3418 12.9374 10.2913 12.6631 10.293 12.3864C10.2956 11.2379 11.2036 10.3002 12.3108 10.3047C12.8417 10.3081 13.3495 10.5316 13.7231 10.9264C14.0967 11.3211 14.3054 11.8548 14.3036 12.4104ZM12.3056 13.9586C12.6981 13.9532 13.0729 13.787 13.3496 13.4957C13.6264 13.2044 13.783 12.8113 13.7861 12.4005C13.7821 11.9897 13.6244 11.597 13.3467 11.3066C13.0691 11.0163 12.6938 10.8515 12.3013 10.8478C11.4872 10.8478 10.8036 11.5655 10.8131 12.414C10.8227 13.2626 11.4976 13.9636 12.3056 13.9586Z"
              fill="url(#paint1_linear_1770_6001)"
            />
            <path
              d="M6.35343 12.4027C6.35286 12.9586 6.14174 13.4917 5.76633 13.8849C5.39093 14.2782 4.88187 14.4997 4.35074 14.5007C3.81951 14.5008 3.30977 14.2812 2.93244 13.8898C2.55511 13.4984 2.34073 12.9669 2.33594 12.4109C2.33765 11.8524 2.55056 11.3173 2.92811 10.9226C3.30566 10.5279 3.81714 10.3058 4.35074 10.3047C4.88162 10.3066 5.39022 10.5283 5.76545 10.9214C6.14069 11.3145 6.35207 11.847 6.35343 12.4027ZM2.86817 12.4005C2.86691 12.8113 3.0212 13.2059 3.29728 13.4979C3.57336 13.79 3.94873 13.9556 4.34123 13.9586C4.73356 13.9584 5.1099 13.7958 5.38825 13.5064C5.6666 13.217 5.8244 12.8242 5.82725 12.4136C5.82879 12.2088 5.79162 12.0056 5.71788 11.8159C5.64414 11.6262 5.53528 11.4536 5.39757 11.3081C5.25987 11.1625 5.09602 11.0469 4.91548 10.968C4.73493 10.889 4.54124 10.8481 4.34555 10.8477C3.95313 10.8493 3.57731 11.0136 3.30039 11.3046C3.02348 11.5957 2.86806 11.9897 2.86817 12.4005Z"
              fill="url(#paint2_linear_1770_6001)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_1770_6001"
                x1="7.25"
                y1="0"
                x2="7.25"
                y2="12.6711"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FBD336" />
                <stop offset="1" stopColor="#E95A19" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_1770_6001"
                x1="12.2983"
                y1="10.3047"
                x2="12.2983"
                y2="14.5008"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FBD336" />
                <stop offset="1" stopColor="#E95A19" />
              </linearGradient>
              <linearGradient
                id="paint2_linear_1770_6001"
                x1="4.34469"
                y1="10.3047"
                x2="4.34469"
                y2="14.5007"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FBD336" />
                <stop offset="1" stopColor="#E95A19" />
              </linearGradient>
            </defs>
          </svg>

          <div className="shadow-themeShadow rounded-md bg-white px-6 py-2 text-black font-medium text-base">
            {props.min_delivery_time}–{props.max_delivery_time} min
          </div>
        </div>
        <div className=" flex gap-2 items-center">
        {/* xl:col-span-1 md:col-span-3 */}
        <div>

        <div className="flex gap-5 pt-3">
          <div className="flex">
            <Rating
              emptySymbol="fa fa-star-o text-[#817d7d]"
              fullSymbol="fa fa-star text-[#FBD336]"
              initialRating={props.rating}
              readonly
              fractions={2}
            />
          </div>
          {props?.rating > 0 ? (
            <div className="text-black text-base">
              ({props?.rating?.toFixed(2)} Excellent)
            </div>
          ) : (
            <div className="text-black text-base">
              {props?.rating?.toFixed(2)}
            </div>
          )}
        </div>
        <p className="text-sm text-[#777777]">
        See all 500 reviews
        </p>
        </div>
        <button
          onClick={() => handleReviewPopUp()}
          className=" flex items-baseline text-[#0DC1D9] "
          // md:pt-14
        >
          
          <AiOutlineRight className="pt-1 text-2xl" />
        </button>
      </div> 
        <div className="text-white font-semibold text-lg px-8 py-2 rounded-md bg-[#E64A19] text-center mt-6">
          50% off entire menu-T&Cs apply
        </div>
     
      </div>
      <RestaurantRatings
        modalIsOpen={modalIsOpen}
        setIsOpen={setIsOpen}
        closeModal={closeModal}
        name={props.name}
        image={props.image}
        categories={props.categories}
        resRating={resRating}
      />
    </div>
  );
};

export default RestaurantDetailsInfo;
